const SUCCEEDED = 'SUCCEEDED'
const FAILED = 'FAILED'

export const actionSucceeded = action => action.type.includes(SUCCEEDED)
export const actionFailed = action => action.type.includes(FAILED)
